import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const TermsOfService = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-32 pb-20">
      <div className="container mx-auto px-4 md:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="max-w-4xl mx-auto bg-white rounded-xl shadow-sm p-8 md:p-12"
        >
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">Terms of Service</h1>
          <div className="prose prose-lg max-w-none text-gray-600">
            <p className="mb-4">Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
            
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">1. Acceptance of Terms</h2>
            <p>
              By accessing or using the ACSE Capital Inc. website, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing this site.
            </p>
            
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">2. Use License</h2>
            <p>
              Permission is granted to temporarily view the materials on ACSE Capital Inc.'s website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Modify or copy the materials;</li>
              <li>Use the materials for any commercial purpose or for any public display;</li>
              <li>Attempt to reverse engineer any software contained on ACSE Capital Inc.'s website;</li>
              <li>Remove any copyright or other proprietary notations from the materials; or</li>
              <li>Transfer the materials to another person or "mirror" the materials on any other server.</li>
            </ul>
            <p>
              This license shall automatically terminate if you violate any of these restrictions and may be terminated by ACSE Capital Inc. at any time.
            </p>
            
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">3. Disclaimer</h2>
            <p>
              The materials on ACSE Capital Inc.'s website are provided on an 'as is' basis. ACSE Capital Inc. makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
            </p>
            <p>
              Further, ACSE Capital Inc. does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its website or otherwise relating to such materials or on any sites linked to this site.
            </p>
            
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">4. Limitations</h2>
            <p>
              In no event shall ACSE Capital Inc. or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on ACSE Capital Inc.'s website, even if ACSE Capital Inc. or a ACSE Capital Inc. authorized representative has been notified orally or in writing of the possibility of such damage.
            </p>
            
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">5. Accuracy of Materials</h2>
            <p>
              The materials appearing on ACSE Capital Inc.'s website could include technical, typographical, or photographic errors. ACSE Capital Inc. does not warrant that any of the materials on its website are accurate, complete, or current. ACSE Capital Inc. may make changes to the materials contained on its website at any time without notice. However, ACSE Capital Inc. does not make any commitment to update the materials.
            </p>
            
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">6. Links</h2>
            <p>
              ACSE Capital Inc. has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by ACSE Capital Inc. of the site. Use of any such linked website is at the user's own risk.
            </p>
            
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">7. Modifications</h2>
            <p>
              ACSE Capital Inc. may revise these terms of service for its website at any time without notice. By using this website, you are agreeing to be bound by the then current version of these terms of service.
            </p>
            
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">8. Governing Law</h2>
            <p>
              These terms and conditions are governed by and construed in accordance with the laws of the United States and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
            </p>
            
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">9. Contact Information</h2>
            <p>
              If you have any questions about these Terms of Service, please contact us at <a href="mailto:admin@acsecapital.com" className="text-primary-600 hover:text-primary-700">admin@acsecapital.com</a>.
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default TermsOfService;
